import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Creates a password reset token to change a user's password
 * @param email user's email
 * @param product Trimble Maps product to request reset token for
 * @param alias account alias (Optional)
 * @returns a password reset token
 */
export function postPasswordResetToken(
  this: unknown,
  request: {
    alias?: string;
    email: string;
    product: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).passwordResetTokenUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(selectData(z.object({ resetToken: z.string() })));
}
